export default "__VITE_ASSET__Cgkoysbr__"